import algoliasearch from "algoliasearch";
import { AlgoliaPaletteHit } from "../types/AlgoliaTypes";
import { algoliaConfig } from "../data/config";

const searchClient = algoliasearch("BCXURW325T", "f9ee2c1748b8d3914488faf0da618532");
const index = searchClient.initIndex(algoliaConfig.PALETTE_INDEX)

export async function getPaletteObject(objectID: string): Promise<AlgoliaPaletteHit> { 
    try { 
        const obj = await index.getObject(objectID);
        return obj as AlgoliaPaletteHit; 
    } catch (err) { 
        throw new Error(); 
    } 
}

export async function getFeaturedPalettes() {
    try {
        const values = await index.search('', {
            filters: `featuredOrder.isFilterable:true`
        })
        
        return values;
    } catch (err) {
        console.log(err)
        throw new Error();
    }
}

export async function getPaletteByRouterValue(routerValue: string): Promise<AlgoliaPaletteHit>{
    try {
        const obj = await index.search(routerValue)
        return obj.hits[0] as AlgoliaPaletteHit;
    } catch (err) {
        console.log(err)
        throw new Error();
    }
}

export async function getCategoryForPalettes(categoryCode?: string): Promise<Record<string, Record<string, number>> | undefined> {
    try {
        const reqOpts = { facets: ['category.label'], filters: `` }
        if(categoryCode && categoryCode.length > 0) {
            reqOpts.filters = `category.code:${categoryCode}`
        }
        const values = await index.search("", reqOpts)
        return values.facets;
    } catch (err) {
        console.log(err)
    }
}